<template>
	<div class="contain-overflow">
		<prebet-matches></prebet-matches>
	</div>
</template>

<script>
import PrebetMatches from "../Prebets/Matches.vue";
import Spinner from "../Shared/Spinner.vue";
let counter = 0;
export default {
	name: "home",
	components: {
		PrebetMatches,
		Spinner,
	},
};
</script>

<style lang="scss">
.content {
	padding-bottom: var(--padding-bottom);
	max-width: var(--app-width);
	.nav {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		overflow: auto;
		margin-bottom: 5px;
		overflow-y: hidden; // hide vertical
		.selected {
			background-color: var(--yellow);
		}
		:first-child {
			margin-left: 5px;
		}
		&:last-child {
			margin-right: 10px;
		}
		&--item {
			height: 50px;
			display: block;
			min-width: 55px;
			background-color: var(--white);
			border: none;
			margin-right: 5px;
			border-radius: 5px;
			box-shadow: 0px 0px 10px -4px rgba(0, 0, 0, 0.75);
			line-height: 0.7;
			color: var(--black);
			&--icon {
				display: block;
				margin: 0 auto !important;
			}
			&--label {
				font-size: var(--font-smallest);
			}
		}
	}
}
</style>
